export enum Role {
  INVOICE = 'ROLE_MARKETPLACE_INVOICE',
  PERMISSION = 'ROLE_MARKETPLACE_PERMISSION',
  DASHBOARD = 'ROLE_MARKETPLACE_DASHBOARD',
  REMOVE_OWNER = 'ROLE_MARKETPLACE_REMOVE_OWNER'
}
